import { ChangeDetectionStrategy, Component, inject, model } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { EditLinks } from '../../../../@core/constants/edit-links';
import { AddressBankAccountLink, AddressBankAccountLinkInput, AddressBankAccountLinkSearchInput } from '../../../../generated/generated-types';
import { NewBaseListComponent } from '../../../../shared/components/new-base-list-component/new-base-list-component';
import { AddressBankAccountLinkService } from '../../services/address-bank-account-link.service';
import { BankAccountLinkEditWidgetComponent } from '../bank-account-link-edit-widget/bank-account-link-edit-widget.component';

@Component({
  selector: 'app-bank-account-link-list-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AddressBankAccountLinkService],
  imports: [
    BaseListWrapperComponent,
  ]
})
export class BankAccountLinkListWidgetComponent extends NewBaseListComponent<AddressBankAccountLink> {

  addressId = model<string>();

  addressBankAccountLinkService: AddressBankAccountLinkService = inject(AddressBankAccountLinkService);
  doubleClickBaseUrl = EditLinks.BANKACCOUNT_LINK;


  constructor() { super("AddressBankAccountLink", inject(AddressBankAccountLinkService)); }

  /**
   * @description Overwrites saveInCRUDService from NewBaseListComponent
   * @param rowData  {{@link AddressBankAccountLink}}
   * @returns Promise<AddressBankAccountLink> {{@link AddressBankAccountLink}}
   */
  override async saveInCRUDService(rowData: AddressBankAccountLink): Promise<AddressBankAccountLink> {
    if (this.addressId() == null) throw new Error("addressId cannot be null");
    // Adding the addressId to the input!
    let input: AddressBankAccountLinkInput = {
      ...rowData as AddressBankAccountLinkInput,
      addressId: this.addressId()
    };
    let ba = await this.addressBankAccountLinkService.saveItem(input);
    return ba;
  }

  getSearchInputForQuery() {
    let si: AddressBankAccountLinkSearchInput = super.getSearchInputForQuery();
    si.addressId = this.addressId();
    return si;
  }

  showEditDialog(rowData?: AddressBankAccountLink, index?: number) {
    const ref = this.baseServices.modalService.fromComponent(BankAccountLinkEditWidgetComponent, {
      size: 'sm',
      verticalAlign: 'top',
      closable: true,
      // fullscreen: true,
      title: this.baseServices.i18nService.translate(_("bank-account-link.edit")),
      locals: {
        detailModel: rowData
      },
      localsSig: {
        addressIdSig: this.addressId
      }
    });

    let sub = ref.subscribe(x => {
      if (x?.id) {
        this.refresh();
        sub.unsubscribe();
      }
    });
  }

}
